import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Box, Button, Card, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, makeStyles } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { Link as RouterLink } from "react-router-dom";

const data = [
  {
    id: uuid(),
    equipmentType: 'Excavator',
    name: 'Ex12',
    department: 'Department XX',
    firm: 'Sany',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Backhoe',
    name: 'Ba12',
    department: 'Department YX',
    firm: 'Nicosail',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Dragline Excavator',
    name: 'Dr34',
    department: 'Department EX',
    firm: 'Amphibious',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Bulldozer',
    name: 'Bu22',
    department: 'Department DX',
    firm: 'Jinpeng',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Grader',
    name: 'Gr33',
    department: 'Department CX',
    firm: 'Liebherr',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Wheel Tractor Scraper',
    name: 'We78',
    department: 'Department BX',
    firm: 'P&H',
    rentDate: 1555016400000
  },
  {
    id: uuid(),
    equipmentType: 'Trencher',
    name: 'Tr44',
    department: 'Department AX',
    firm: 'Ultratrex',
    rentDate: 1555016400000
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
  otherButton: {
    marginBottom: theme.spacing(3)
  }
}));

const RentedEquipmentList = ({ className, ...rest }) => {
  const classes = useStyles();
  const [selectedWorkRequestIds, setSelectedWorkRequestIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [workrequests] = useState(data);

  const handleSelectAll = (event) => {
    let newSelectedWorkRequestIds;

    if (event.target.checked) {
      newSelectedWorkRequestIds = workrequests.map((workrequest) => workrequest.id);
    } else {
      newSelectedWorkRequestIds = [];
    }

    setSelectedWorkRequestIds(newSelectedWorkRequestIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedWorkRequestIds.indexOf(id);
    let newSelectedWorkRequestIds = [];

    if (selectedIndex === -1) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds, id);
    } else if (selectedIndex === 0) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds.slice(1));
    } else if (selectedIndex === selectedWorkRequestIds.length - 1) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(selectedWorkRequestIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedWorkRequestIds = newSelectedWorkRequestIds.concat(
        selectedWorkRequestIds.slice(0, selectedIndex),
        selectedWorkRequestIds.slice(selectedIndex + 1)
      );
    }

    setSelectedWorkRequestIds(newSelectedWorkRequestIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div>
      <Button className={classes.otherButton} color="primary" variant="outlined" component={RouterLink} to="../equipment_renting_form">Rent Equipment</Button>
      <Card className={clsx(classes.root, className)} {...rest}>      
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Equipment Type</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Department</TableCell>
                  <TableCell>Firm</TableCell>
                  <TableCell>Rent Date</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {workrequests.slice(0, limit).map((workrequest) => (
                  <TableRow hover key={workrequest.id} selected={selectedWorkRequestIds.indexOf(workrequest.id) !== -1}>
                    <TableCell>{workrequest.equipmentType}</TableCell>
                    <TableCell>{workrequest.name}</TableCell>
                    <TableCell>{workrequest.department}</TableCell>
                    <TableCell>{workrequest.firm}</TableCell>
                    <TableCell>{moment(workrequest.rentDate).format('DD/MM/YYYY')}</TableCell>                  
                    <TableCell><Button variant="outlined">Extend Renting</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination component="div" 
          count={workrequests.length}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[10, 50, 100]} />
      </Card>
    </div>
  );
};

RentedEquipmentList.propTypes = {
  className: PropTypes.string,
  workrequests: PropTypes.array.isRequired
};

export default RentedEquipmentList;
